module.exports = __webpack_public_path__ + "nc_static/media/service_contract_refresh.2c21773d.svg";